var axios = require("axios");
import { API_URL } from "@/common/config";
import JwtService from "@/common/jwt.service";
import {
  FETCH_NOTIFICATION_LIST,
  GET_NOTIFICATION,
  CREATE_NOTIFICATION,
  CREATE_USER_NOTIFICATION
} from "./actions.type";

const initialState = {
  notificationList: []
};

export const state = { ...initialState };

export const actions = {
  async[FETCH_NOTIFICATION_LIST](context, payload) {
    var postData = payload;
    // console.log("TOKEN: " + JwtService.getToken())
    var config = {
      method: 'post',
      url: `${API_URL}/v1/notifications/list`,
      headers: {
        'Content-Type': 'text/plain',
        //'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + JwtService.getToken(),
        //'Access-Control-Allow-Origin': '*'
      },
      data: postData
    };
    return new Promise(resolve => {
      axios(config)
        .then(function (response) {
          // console.log(JSON.stringify(response.data));
          resolve(response.data.data)
        })
        .catch(function (error) {
          console.log(error)
          resolve(error)
        });
    });
  },
  async[GET_NOTIFICATION](context, notificationID) {
    var config = {
      method: 'get',
      url: `${API_URL}/v1/notifications/${notificationID}`,
      headers: {
        'Content-Type': 'text/plain',
        //'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + JwtService.getToken()
      }
    };
    return await new Promise(resolve => {
      axios(config)
        .then(function (response) {
          resolve(response.data.data)
        })
        .catch(function (error) {
          console.log(error)
          resolve(error)
        });
    });
  },
  async[CREATE_USER_NOTIFICATION](context, payload) {
    var notificationData = payload.notificationData;
    var config = {
      method: 'post',
      url: `${API_URL}/v1/notifications/user`,
      headers: {
        //'Content-Type': 'text/plain',
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + JwtService.getToken()
      },
      data: notificationData
    };
    return await new Promise(resolve => {
      axios(config)
        .then(function (response) {
          resolve(response)
        })
        .catch(function (error) {
          console.log(error)
          resolve(error)
        });
    });
  },
  async[CREATE_NOTIFICATION](context, payload) {
    var notificationData = payload.notificationData;
    console.log(notificationData)
    var config = {
      method: 'post',
      url: `${API_URL}/v1/notifications/create`,
      headers: {
        // 'Content-Type': 'text/plain',
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + JwtService.getToken()
      },
      data: notificationData
    };
    return new Promise(resolve => {
      axios(config)
        .then(function (response) {
          resolve(response)
        })
        .catch(function (error) {
          console.log(error)
          resolve(error)
        });
    });
  }
};

/* eslint no-param-reassign: ["error", { "props": false }] */
export const mutations = {
};

const getters = {
};

export default {
  state,
  actions,
  mutations,
  getters
};
